/* App config for apis
 */

export const IS_DEV = process.env.NODE_ENV === 'development';

export const DOMAIN_NAME = 'https://us-central1-minipt-1.cloudfunctions.net/waitlist/';

const ApiConfig = {
  AUTH_HEADER: '',
  BASE_URL: DOMAIN_NAME,

  SIGNUP: 'signup',
  LOGIN: 'login',

  WAITLIST_API_HOST: 'waitlist',

  CLOUD_FUNCTIONS_BASE_URL: 'https://us-central1-minipt-1.cloudfunctions.net/',
  CREATE_USER_PROFILE_API_HOST: 'create_user_profile',
  SUMMARIZE_INSTRUCTION_API_HOST: 'summarize_instruction',
  SUMMARIZE_INSTRUCTION_PROD_API_HOST: 'summarize_instruction_prod',
  GENERATE_WORKOUT_PROGRAM_COACH_API_HOST: 'generate_workout_program_coach',
  USER_BEHAVIOR_TRACKER_API_HOST: 'user_behavior_tracker',

  // Onboarding API endpoints
  TRAINER_GET_ONBOARDING_MASTER_DATA: 'trainer_get_onboarding_master_data',
  TRAINER_GET_ONBOARDING_STATE: 'trainer_get_onboarding_state',
  TRAINER_SAVE_ONBOARDING_STEP: 'trainer_save_onboarding_step',
  TRAINER_GET_SCHEDULE: 'trainer_get_schedule',
  TRAINER_UPDATE_SCHEDULE: 'trainer_update_schedule',
  TRAINER_CHECK_SCHEDULE_CONFLICTS: 'trainer_check_schedule_conflicts',
  TRAINER_GET_PROGRAM_MASTER_DATA: 'trainer_get_program_master_data',
  TRAINER_SAVE_PROGRAM_PROGRESS: 'trainer_save_program_progress',
  TRAINER_GET_PROGRAMS: 'trainer_get_programs',
  TRAINER_GET_ALL_MOVEMENTS: 'trainer_get_all_movements',

  // Client API endpoints
  TRAINER_ADD_CLIENT: 'trainer_add_client',
  TRAINER_GET_CLIENTS: 'trainer_get_clients',
  TRAINER_UPDATE_CLIENT_STATUS: 'trainer_update_client_status',
  TRAINER_UPDATE_PROFILE: 'trainer_update_profile',
  TRAINER_GET_CLIENT_FITNESS_PROFILE: 'trainer_get_client_fitness_profile',
  TRAINER_GET_CLIENT_WORKOUT_DETAILS: 'trainer_get_client_workout_details',
  TRAINER_GET_CLIENT_PROGRAM_TAB: 'trainer_get_client_program_tab',
  TRAINER_GET_CLIENT_PROFILE_TAB: 'trainer_get_client_profile_tab',
  TRAINER_GET_CLIENT_WORKOUTS_TAB: 'trainer_get_client_workouts_tab',
  TRAINER_GET_CLIENT_OVERVIEW: 'trainer_get_client_overview',
  TRAINER_GET_CLIENT_NOTES: 'trainer_get_client_notes',
  TRAINER_ADD_CLIENT_NOTE: 'trainer_add_client_note',
  TRAINER_DELETE_CLIENT_NOTE: 'trainer_delete_client_note',
  TRAINER_PIN_CLIENT_NOTE: 'trainer_pin_client_note',

  // Messages API endpoints
  TRAINER_GET_MESSAGES: 'trainer_get_messages',
  TRAINER_GET_UNREAD_MESSAGES: 'trainer_get_unread_messages',
  TRAINER_GET_CHAT_MEDIA: 'trainer_get_chat_media',
  TRAINER_SEARCH_CONVERSATION_MESSAGES: 'trainer_search_conversation_messages',
  TRAINER_GET_MESSAGE_CONTEXT_WINDOW: 'trainer_get_message_context_window',

  // Check-ins API endpoints
  TRAINER_GET_CHECKINS: 'trainer_get_checkins',
  TRAINER_GET_CHECKIN_DETAILS: 'trainer_get_checkin_details',
  TRAINER_MARK_CHECKIN_READ: 'trainer_mark_checkin_read',
  TRAINER_CONFIRM_CHECKIN: 'trainer_confirm_checkin',
  TRAINER_COMPLETE_CHECKIN: 'trainer_complete_checkin',
  TRAINER_GET_ZOOM_MEETING_STATUS: 'trainer_get_zoom_meeting_status',
  TRAINER_SUGGEST_CHECKIN: 'trainer_suggest_checkin',
  TRAINER_DECLINE_CHECKIN: 'trainer_decline_checkin',
  TRAINER_SEND_CHECKIN_REMINDER: 'trainer_send_checkin_reminder',
  TRAINER_UPDATE_CHECKIN_ACTION_ITEMS: 'trainer_update_checkin_action_items',

  // Support Reports & Block Client API endpoints
  TRAINER_SUBMIT_SUPPORT_REPORT: 'trainer_submit_support_report',
  TRAINER_BLOCK_CLIENT: 'trainer_block_client',
  TRAINER_UNBLOCK_CLIENT: 'trainer_unblock_client',
  // Program Plan API endpoints
  GENERATE_WORKOUT_PROGRAM_COACH_PROD_API_HOST: 'trainer_generate_workout_program',
  TRAINER_CREATE_PROGRAM_DRAFT: 'trainer_create_program_draft',
  TRAINER_SAVE_PROGRAMME_PLAN: 'trainer_save_programme_plan',
  TRAINER_GET_PROGRAM_PLAN_LIST: 'trainer_get_program_plan_list',
  TRAINER_GET_PROGRAM_PLAN_BY_ID: 'trainer_get_program_plan_by_id',
  TRAINER_ARCHIVE_PROGRAM_PLAN: 'trainer_archive_program_plan',
  TRAINER_DELETE_PROGRAM_PLAN: 'trainer_delete_program_plan',
  TRAINER_DUPLICATE_PROGRAM_PLAN: 'trainer_duplicate_program_plan',
  TRAINER_SEND_PROGRAMME_PLAN_TO_CLIENT: 'trainer_send_programme_plan_to_client',
  TRAINER_UPDATE_PROGRAMME_CALENDAR: 'trainer_update_programme_calendar',

  // Subscription API endpoints
  SUBSCRIPTION_API_BASE: 'subscription_api',
  TRAINER_GET_ENTITLEMENTS: 'trainer_get_entitlements',
  TRAINER_CHECK_FEATURE_ACCESS: 'trainer_check_feature_access',
  TRAINER_GET_SUBSCRIPTION_PLANS: 'trainer_get_subscription_plans',
  TRAINER_GET_TRIAL_ELIGIBILITY: 'trainer_get_trial_eligibility',
  TRAINER_PREVIEW_CHECKOUT: 'trainer_preview_checkout',
  TRAINER_VALIDATE_PROMO_CODE: 'trainer_validate_promo_code',
  TRAINER_CHECKOUT_SUBSCRIPTION: 'trainer_checkout_subscription',
  TRAINER_SYNC_SUBSCRIPTION: 'trainer_sync_subscription',
  TRAINER_GET_PAYMENT_OPERATION_STATUS: 'trainer_get_payment_operation_status',
  TRAINER_GET_TERMS_OF_SERVICE: 'trainer_get_terms_of_service',
  TRAINER_GET_PRIVACY_POLICY: 'trainer_get_privacy_policy',
  TRAINER_RECORD_LEGAL_ACKNOWLEDGEMENT: 'trainer_record_legal_acknowledgement',
  TRAINER_GET_BILLING_PROFILE: 'trainer_get_billing_profile',
  TRAINER_SAVE_BILLING_PROFILE: 'trainer_save_billing_profile',
  TRAINER_VALIDATE_BILLING_PROFILE: 'trainer_validate_billing_profile',
  TRAINER_CREATE_SETUP_INTENT: 'trainer_create_setup_intent',
  TRAINER_GET_STRIPE_CONFIG: 'trainer_get_stripe_config',
  TRAINER_GET_PAYMENT_METHODS: 'trainer_get_payment_methods',
  TRAINER_SAVE_PAYMENT_METHOD: 'trainer_save_payment_method',
  TRAINER_SET_DEFAULT_PAYMENT_METHOD: 'trainer_set_default_payment_method',
  TRAINER_REPLACE_PAYMENT_METHOD: 'trainer_replace_payment_method',
  TRAINER_DELETE_PAYMENT_METHOD: 'trainer_delete_payment_method',
  TRAINER_GET_SUBSCRIPTION_STATE: 'trainer_get_subscription_state',
  TRAINER_CANCEL_SUBSCRIPTION: 'trainer_cancel_subscription',
  TRAINER_REACTIVATE_SUBSCRIPTION: 'trainer_reactivate_subscription',
  TRAINER_SWITCH_BILLING_INTERVAL_PREVIEW: 'trainer_switch_billing_interval_preview',
  TRAINER_SWITCH_BILLING_INTERVAL: 'trainer_switch_billing_interval',
  TRAINER_CANCEL_SCHEDULED_INTERVAL_SWITCH: 'trainer_cancel_scheduled_interval_switch',
  TRAINER_RETRY_INVOICE_PAYMENT: 'trainer_retry_invoice_payment',
  TRAINER_GET_BILLING_HISTORY: 'trainer_get_billing_history',
  TRAINER_GET_INVOICE_DOWNLOAD_URL: 'trainer_get_invoice_download_url',
  TRAINER_DOWNLOAD_ALL_INVOICES: 'trainer_download_all_invoices',
  TRAINER_GET_EXPORT_STATUS: 'trainer_get_export_status',
  TRAINER_GET_SUPPORT_CONFIG: 'trainer_get_support_config',
  TRAINER_CONTACT_SUPPORT: 'trainer_contact_support',
  TRAINER_DELETE_SUPPORT_ATTACHMENT: 'trainer_delete_support_attachment',
  TRAINER_PREVIEW_ACCOUNT_DELETION: 'trainer_preview_account_deletion',
  TRAINER_REQUEST_ACCOUNT_DELETION: 'trainer_request_account_deletion',
  TRAINER_GET_ACCOUNT_DELETION_STATUS: 'trainer_get_account_deletion_status',
};

export default ApiConfig;
